import React from 'react';
import { FundedLoansDashboard } from './components/FundedLoansDashboard';
export function App() {
  return <FundedLoansDashboard data-id="element-0" />;
}